import { DatePipe, NgClass, NgTemplateOutlet } from '@angular/common';
import {
    Component,
    type TemplateRef,
    ViewEncapsulation,
    inject,
    input,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { Message } from '@clean-code/models';
import {
    NotificationService,
} from '@clean-code/notifications/domain';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
    selector: 'notifications-notification-item',
    templateUrl: './notification-item.component.html',
    styleUrls: ['./notification-item.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    imports: [
        NgTemplateOutlet,
        NgClass,
        DatePipe,
        MatButtonModule,
        TranslocoModule,
    ]
})
export class NotificationItemComponent {
  private notificationService = inject(NotificationService);

  public message = input.required<Message>();
  public subjectTemplate = input<TemplateRef<any>>();
  public bodyTemplate = input<TemplateRef<any>>();

  public showDetails = false;

  public toggleDetails($event: Event): void {
    $event.stopPropagation();
    $event.preventDefault();
    this.showDetails = !this.showDetails;
  }

  public markAsRead($event: Event): void {
    $event.stopPropagation();
    $event.preventDefault();
    if (!this.message().isRead) {
      this.notificationService.setNotificationRead(this.message().id);
    }
  }
}
